import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store";
import vuetify from "@/plugins/vuetify";
import axios from "axios";
import "./date.extensions";
import PrimeVue from "primevue/config";
import eventTracking from "./../services/EventTracking";
import LogRocket from "logrocket";

if (
  window.location.href.includes("mhhcc-portal") ||
  window.location.href.includes("mhhcc-dev-portal")
) {
  LogRocket.init("z0ys5q/maintreq");
}

let startTime = 0;

axios.interceptors.request.use(req => {
  startTime = performance.now();
  eventTracking.writeApiRequestStartEvent(
    req.url as string,
    req.method as string,
    req.headers
  );

  return Promise.resolve(req);
});

axios.interceptors.response.use(resp => {
  eventTracking.writeApiRequestEndEvent(
    performance.now() - startTime,
    resp.status,
    resp.config.url || "",
    resp.status > 302 ? resp.data : ""
  );
  startTime = 0;
  return resp;
});

Vue.use(PrimeVue);
Vue.config.productionTip = false;
Vue.config.errorHandler = (err, vm) =>
  eventTracking.writeApplicationErrorEvent(err.message, vm, err.stack || "");
Vue.prototype.$http = axios;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
